var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/footer_css';
let Footer = class Footer extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'full';
        this.aim = 'gs1';
        this.headCol = 5;
        this.image = '';
        this.disclaimer = 'GS1 Italy Disclaimer';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    firstUpdated() {
        const gs1HeadFooter = this.shadowRoot?.querySelector('.gs1-footer #head-footer');
        const gs1SubFooter = this.shadowRoot?.querySelector('.gs1-footer #sub-footer');
        if (this.image != '') {
            const div = document.createElement('div');
            const img = document.createElement('img');
            img.src = this.image;
            div.classList.add('col');
            div.appendChild(img);
            gs1HeadFooter?.appendChild(div);
        }
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                if (item.getAttribute('data-gs1wc-type') == 'head') {
                    if (item.hasAttribute('data-gs1wc-title')) {
                        const title = document.createElement('h4');
                        title.innerText = item.getAttribute('data-gs1wc-title');
                        item.prepend(title);
                    }
                    const div = document.createElement('div');
                    div.classList.add('col');
                    for (let i = 0, l = item.classList.length; i < l; ++i) {
                        if (/d-.*/.test(item.classList[i])) {
                            div.classList.add(item.classList[i]);
                        }
                    }
                    div.appendChild(item);
                    gs1HeadFooter?.appendChild(div);
                }
                else {
                    item.classList.add('subfooter-links');
                    gs1SubFooter?.prepend(item);
                }
            }
        });
    }
    render() {
        return html ` ${env.debug
            ? html `<link rel="stylesheet" href="/css/footer.css" />`
            : html ``}
      <footer class="gs1-footer">
        <div class="container">
          ${this.type == 'small'
            ? html `<gs1-social
                aim="${this.aim}"
                class="social-icons col"
              ></gs1-social>`
            : html ``}
          <div
            id="head-footer"
            class="row row-cols-1 row-cols-lg-${this.headCol}"
          ></div>

          <hr />

          <div class="row">
            ${this.type == 'full'
            ? html `<gs1-social
                  aim="${this.aim}"
                  class="social-icons col-12 col-md-4 col-lg-3 col-xl-2"
                ></gs1-social>`
            : html ``}
            <div id="sub-footer" class="col-12 col-md-8 col-lg-9 col-xl-10">
              <div class="disclaimer">
                <p>${this.disclaimer}</p>
              </div>
            </div>
          </div>
        </div>
      </footer>`;
    }
};
__decorate([
    property()
], Footer.prototype, "type", void 0);
__decorate([
    property()
], Footer.prototype, "aim", void 0);
__decorate([
    property()
], Footer.prototype, "headCol", void 0);
__decorate([
    property()
], Footer.prototype, "image", void 0);
__decorate([
    property()
], Footer.prototype, "disclaimer", void 0);
Footer = __decorate([
    customElement('gs1-footer')
], Footer);
export { Footer };
//# sourceMappingURL=footer.js.map